@let request = $request();
@let status = request?.statusId;
@let isLoading = !!(isLoading$ | async);
@let isMobile = $isMobile();
@let dropdownOpen = $dropdownOpen();
@if (status && this.$requestStatuses().length) {
  <aside
    (click)="toggleDropdown()"
    [title]="'request_statuses.' + status!.id | translate"
  >
    <button
      appearance="outline"
      tuiButton
      size="m"
      class="complete-button outline-without-borders max-w-none! px-3!"
      [style.background]="hexToRgba(status!.color, 0.5)"
      [tuiDropdown]="changeStatusContent"
      [tuiDropdownManual]="dropdownOpen"
      [tuiDropdownMaxHeight]="1000"
      [tuiDropdownMinHeight]="1000"
      [tuiDropdownAlign]="isMobile ? 'center' : 'end'"
      [tuiSkeleton]="isLoading"
      [ngClass]="{
        'h-[34px]! w-[183px]! rounded-[12px]!': isMobile,
        'h-[46px]! w-[222px]! rounded-[79px]!': !isMobile,
      }"
      [disabled]="isLoading"
      [iconEnd]="dropdownOpen ? '@tui.chevron-up' : '@tui.chevron-down'"
    >
      <span
        class="truncate"
        [ngClass]="{
          'x-font-body-4-bold': isMobile,
          'x-font-body-3-bold': !isMobile,
        }"
      >
        {{ 'request_statuses.' + status!.id | translate }}
      </span>
    </button>
  </aside>
}

<ng-template #changeStatusContent>
  <x-request-form-status
    [insideDropdown]="true"
    (statusChangeInProcess)="statusChangeInProcessChange($event)"
  />
</ng-template>
